import { SwConfigVariables } from "../components/modules/asset/masters/items/configurations/queries/type";
import { ConfigLabels } from "../utils/Enum.types";
import useSwConfigData from "./useSwConfigData";

const useLabels = () => {
  const { configData } = useSwConfigData([
    ConfigLabels.COMPANY_LABEL,
    ConfigLabels.SUBSIDIARY_LABEL,
    ConfigLabels.LDGR_LABEL,
    ConfigLabels.ITEM_LABEL,
    ConfigLabels.SUBSIDIARY_SITE_LABEL,
    ConfigLabels.JUNCTION_LABEL,
  ]);
  const filterDataByConfigKey = (data: SwConfigVariables[]) => {
    let companyLabel = "";
    let subsidiaryLabel = "";
    let ledgerLabel = "";
    let itemLabel = "";
    let subsidiarySiteLabel = "";
    let junctionLabel = "";

    if (data) {
      data.forEach((item) => {
        switch (item.configKey) {
          case ConfigLabels.COMPANY_LABEL:
            companyLabel = item.str1Value;
            break;
          case ConfigLabels.SUBSIDIARY_LABEL:
            subsidiaryLabel = item.str1Value;
            break;
          case ConfigLabels.LDGR_LABEL:
            ledgerLabel = item.str1Value;
            break;
          case ConfigLabels.ITEM_LABEL:
            itemLabel = item.str1Value;
            break;
          case ConfigLabels.SUBSIDIARY_SITE_LABEL:
            subsidiarySiteLabel = item.str1Value;
            break;
          case ConfigLabels.JUNCTION_LABEL:
            junctionLabel = item.str1Value;
            break;

          default:
            break;
        }
      });
    }
    return {
      companyLabel,
      subsidiaryLabel,
      ledgerLabel,
      itemLabel,
      subsidiarySiteLabel,
      junctionLabel,
    };
  };

  const {
    companyLabel,
    subsidiaryLabel,
    ledgerLabel,
    itemLabel,
    subsidiarySiteLabel,
    junctionLabel,
  } = filterDataByConfigKey(configData.data?.GetSwConfigVariables!);
  return {
    companyLabel,
    subsidiaryLabel,
    ledgerLabel,
    itemLabel,
    subsidiarySiteLabel,
    configData,
    junctionLabel,
  };
};

export default useLabels;
